import React, { useEffect, useState } from 'react';
import PurchaseOrderFieldCustomisation from './components/purchaseOrderFieldCustomisation';
import Button from '../../../../../component/ui/Button';
import PurchaseOrderGeneral from './components/purchaseOrderGeneral';
import { stringToBool } from '../../../../../utils/utility';
import { getPOGeneral, UpdatePOGeneral } from '../../../../../services/settings/purchases';
import { toast } from 'react-toastify';
import SettingHeaderComponent from '../../components/settingHeaderComponent';
import { useSearchParams } from 'react-router-dom';

export default function SettingsPurchaseOrder({ activeTab }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [tab, setTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [poLoader, setPOLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState(false);
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [generalForm, setGeneralForm] = useState({});
	const [form, setForm] = useState({});

	const handlePOGeneral = async () => {
		try {
			setPOLoader((prev) => ({
				...prev,
				isLoader: true,
				isSave: true,
			}));
			setIsEdit(false);
			const res = await UpdatePOGeneral(form);
			if (res.success) {
				toast.success(res.message);
				getGeneralDetail();
			} else {
				setIsEdit(true);
				toast.error(res.message);
			}
		} catch (error) {
			setIsEdit(true);
		} finally {
			setPOLoader((prev) => ({
				...prev,
				isLoader: false,
				isSave: false,
			}));
		}
	};
	const handleCustomField = () => { };

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(generalForm) !== JSON.stringify(form);
		setIsEdit(hasChanged);
	};

	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);

	const getGeneralDetail = async () => {
		try {
			setPOLoader((prev) => ({
				...prev,
				isLoader: true,
				isGetData: true,
			}));
			const { purchase_order_settings } = await getPOGeneral();
			var data = {
				enable_auto_create_purchase_order:
					purchase_order_settings.enable_auto_create_purchase_order !== null
						? stringToBool(purchase_order_settings.enable_auto_create_purchase_order)
						: false,
				terms_and_conditions:
					purchase_order_settings.terms_and_conditions !== null &&
						purchase_order_settings.terms_and_conditions !== 'null'
						? purchase_order_settings.terms_and_conditions
						: '',
				customer_notes:
					purchase_order_settings.customer_notes !== null &&
						purchase_order_settings.customer_notes !== 'null'
						? purchase_order_settings.customer_notes
						: '',
			};
			setForm(data);
			setGeneralForm(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setPOLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		if (tab === 'General') {
			url.set('type', 'purchase-order-general')
		} else {
			url.set('type', 'field-customisation');
		}
		setSearchParams(url);
	}

	useEffect(() => {
		setUrlSearchParams()
	}, [tab]);


	const setFilterFromUrl = () => {
		setTab(searchParams.get('type') === 'field-customisation' ? 'Field Customisation' : 'General')

	}

	useEffect(() => {
		setFilterFromUrl()
	}, []);

	useEffect(() => {
		if (tab === 'General') {
			getGeneralDetail();
		} else if (tab === 'Field Customisation') {
		}
	}, [searchParams]);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={tab === 'Field Customisation' ? [
					{
						id: 1,
						button: 'Add New Custom Field',
						add: true,
						close: false,
						disabled: false,
						handler: () => {
							setIsCreateForm(true)
						},
						className: 'btn-primary',
					},

				] : [
					{
						id: 1,
						disabled: !isEdit || poLoader.isLoader && poLoader.isSave,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Save',
						loader: poLoader.isLoader && poLoader.isSave,
						handler: () => {
							handlePOGeneral();
						},
					},
					isEdit && {
						id: 2,
						disabled: false,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Undo Changed',
						handler: () => {
							setIsEdit(false);
							getGeneralDetail();
						},
					}
				].filter((button) => button !== false)}
			/>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 0, zIndex: 100 }}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${tab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{tab === 'General' ? (
				<PurchaseOrderGeneral
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					poLoader={poLoader}
				/>
			) : (
				<PurchaseOrderFieldCustomisation
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}
		</div>
	);
}
